import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer.js";
import { Helmet } from "react-helmet-async";

import Choose from "./Choose.js";

import services_header from "../../assets/services-header.jpg";
import services_heart_icon from "../../assets/services-heart-icon.png";
import services_heart from "../../assets/services-heart.png";
import services_wellness from "../../assets/services-wellness.jpg";
import services_metabolic from "../../assets/services-metabolic.jpg";
import services_nutrition from "../../assets/services-nutrition.jpg";
import services_personal from "../../assets/services-personal.jpg";
import green_jump_rope from "../../assets/green-jump-rope.jpg";
import purple_kettle_bell from "../../assets/purple-kettle-bell.jpg";

const Services = (props) => {
  const [tabs, setTabs] = useState(props.context.servicesTabs || {
    wellness: "-active",
    metabolic: "",
    nutrition: "",
    personal: "",
  });

  const toggleTab = (e, which) => {
    // e.preventDefault();
    // console.log(which)
    let newTabs = {
      wellness: "",
      metabolic: "",
      nutrition: "",
      personal: "",
    };
    newTabs[which] = "-active";
    // console.log(newTabs);
    setTabs(newTabs);
  };

  return (
    <div className="container-page">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="description" content="It's A Good Life Fitness" />
        <title>It's A Good Life Fitness | Services</title>
        <link rel="canonical" href="https://itsagoodlifefitness.com" />
      </Helmet>
      <div className="services-header">
        <div className="header-description">
          <div className="description-image">
            <img src={services_heart_icon} width="87" height="81" alt="Heart" />
          </div>
          <h1>Hack Your Fitness Regime</h1>
          <p>
            Our expert trainers and nutritionists at IGLF offer personalized
            healthy lifestyle coaching to help you hack your fitness regime.
            Offering 6 and 12-week programs to accommodate your schedule, our
            certified fitness coaches partner with you to devise a health &
            wellness routine that matches your goals. No matter whether your
            fitness goals are geared towards WEIGHT LOSS, GET FIT, STAY FIT or
            KEEP MOVING, you can trust that It’s A Good Life Fitness is here to
            support you through it all. Get started today for the perfect
            package tailored just for you!
          </p>
        </div>
        <div className="header-image">
          <img
            src={services_header}
            height="476"
            width="642"
            alt="Woman stretching"
          />
        </div>
      </div>
      <section className="tabs" id="services">
        <div className="tab-buttons">
          <div
            className={`tab-button${tabs.wellness}`}
            onClick={(e) => toggleTab(e, "wellness")}
            id="wellness-assessment"
          >
            Wellness Assessment
          </div>
          <div className="tab-spacer"></div>
          <div
            className={`tab-button${tabs.metabolic}`}
            onClick={(e) => toggleTab(e, "metabolic")}
            id="metabolic-testing"
          >
            Metabolic Testing
          </div>
          <div className="tab-spacer"></div>
          <div
            className={`tab-button${tabs.nutrition}`}
            onClick={(e) => toggleTab(e, "nutrition")}
            id="nutrition"
          >
            Nutrition Coaching
          </div>
          <div className="tab-spacer"></div>
          <div
            className={`tab-button${tabs.personal}`}
            onClick={(e) => toggleTab(e, "personal")}
            id="personal-training"
          >
            Personal Training
          </div>
        </div>
        {/* ****** */}
        <div className={`tab${tabs.wellness}`}>
          <div className="tab-image">
            <img
              src={services_wellness}
              height="392"
              width="703"
              alt="Woman with clipboard"
            />
          </div>
          <div className="tab-description">
            <div className="description-container">
              <h2>Wellness Assessment</h2>
              <p>
                This session is centered around goal setting and fitness
                assessments to measure your body movements, physical readiness,
                and current habits.
              </p>
              <div className="description-background">
                <img src={services_heart} width="435" height="404" alt="Heart" />
              </div>
            </div>
          </div>
        </div>
        {/* ****** */}
        <div className={`tab${tabs.metabolic}`}>
          <div className="tab-image">
            <img
              src={services_metabolic}
              height="392"
              width="703"
              alt="Woman on treadmill"
            />
          </div>
          <div className="tab-description">
            <div className="description-container">
              <h2>Metabolic Testing</h2>
              <p>
                Ready to understand your unique composition? In order to better
                meet your goals, IGLF offers extensive metabolic testing to
                comprehend how YOUR body works inside and out.
              </p>
              <div className="description-background">
                <img src={services_heart} width="435" height="404" alt="Heart" />
              </div>
            </div>
          </div>
        </div>
        {/* ****** */}
        <div className={`tab${tabs.nutrition}`}>
          <div className="tab-image">
            <img
              src={services_nutrition}
              height="392"
              width="703"
              alt="Man with clipboard"
            />
          </div>
          <div className="tab-description">
            <div className="description-container">
              <h2>Nutrition Coaching</h2>
              <p>
                As the saying goes - you are what you eat! That’s why our expert
                nutrition coaches customize a healthy nutrition plan with your unique
                body type, eating habits, and fitness goals in mind.
              </p>
              <div className="description-background">
                <img src={services_heart} width="435" height="404" alt="Heart" />
              </div>
            </div>
          </div>
        </div>
        {/* ****** */}
        <div className={`tab${tabs.personal}`}>
          <div className="tab-image">
            <img
              src={services_personal}
              height="392"
              width="703"
              alt="Kettle bell training"
            />
          </div>
          <div className="tab-description">
            <div className="description-container">
              <h2>Personal Training</h2>
              <p>
                Now offering virtual and in-person training, there are no more
                excuses for not having time to hit the gym! Instead, we keep you
                motivated and on-track during our personal one-on-one workout
                sessions specifically tailored to you.
              </p>
              <div className="description-background">
                <img src={services_heart} width="435" height="404" alt="Heart" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Choose {...props} />
      <section className="wellness-portal" id="wellness-portal">
        <div className="image" id="green-jump-rope">
          <img src={green_jump_rope} width="409" height="409" alt="Green jump rope" />
        </div>
        <div className="description">
          <h3>The Wellness Portal</h3>
          <p>
            Designed to optimize your fitness journey with easy access to
            nutritional recipes, educational content and communication with your
            coach, our Wellness Portal is the hub for all important news and
            activity. Integrated with an intelligent tracking system to measure
            your progress and record personal milestones, you can finally focus
            on what’s important - your mental and physical wellbeing.
          </p>
        </div>
        <div className="image" id="purple-kettle-bell">
          <img src={purple_kettle_bell} width="306" height="273" alt="Purple kettle bell" />
        </div>
      </section>
      <section className="book-now">
        <article className="description">
          <h2>
            Not Ready for a long-term commitment? Book an individual training,
            nutrition, metabolic assessment, or wellness session!
          </h2>
        </article>
        <div className="button-container">
          <Link to="/individual/"><button className="button">Book Now</button></Link>
        </div>
      </section>
      <Footer {...props}/>
    </div>
  );
};

export default Services;
